import Badge from "@mui/material/Badge";
import { ComponentProps } from "../types";

function Component({ component }: ComponentProps) {
	return <Badge key={component.id} />;
}

export default Component;
